import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import AutoImportService from './AutoImportService';

const MachineResultImport = ({ 
  formData, 
  setFormData,
  setSelectedUser,
  setSearchKey,
  setShowSearchDropdown
}) => {
  const [autoImportEnabled, setAutoImportEnabled] = useState(false);
  const [watchFolder, setWatchFolder] = useState('D:\\LIS_Import'); // Default folder
  const [lastImportTime, setLastImportTime] = useState(null);
  const [importedCount, setImportedCount] = useState(0);
  const [importLog, setImportLog] = useState([]);

  // Cleanup on unmount
  useEffect(() => {
    return () => {
      AutoImportService.stopWatching();
    };
  }, []);

  // Toggle auto-import
  const toggleAutoImport = () => {
    if (autoImportEnabled) {
      // Stop
      AutoImportService.stopWatching();
      setAutoImportEnabled(false);
    } else {
      // Start
      AutoImportService.startWatching(watchFolder, handleAutoImport);
      setAutoImportEnabled(true);
      toast.success('🚀 Auto-import enabled! Drop files in folder to auto-import.');
    }
  };

  // Handle auto import callback
  const handleAutoImport = async (patientId, parsedResults, filename) => {
    try {
      console.log('Auto-importing for patient:', patientId);

      // Find patient in list
      const patient = formData.l1.find(p => 
        String(p.lab_reg_uhid).trim() === String(patientId).trim() ||
        String(p.lab_reg_id).trim() === String(patientId).trim()
      );

      if (!patient) {
        toast.error(`❌ Patient ${patientId} not found in today's list`);
        addToLog(`Failed: Patient ${patientId} not found`, 'error');
        return;
      }

      // Auto-select patient
      setSelectedUser(patient);
      setSearchKey(`${patient.lab_reg_name} (${patient.lab_reg_uhid})`);
      setShowSearchDropdown(false);

      // Load patient tests
      const patientTests = formData.l1.filter(i => i.lab_item_parent === patient.lab_item_parent);
      
      // Map and import results
      let mappedCount = 0;
      const updatedTests = patientTests.map(test => {
        const updatedParams = test.params.map(param => {
          const machineResult = findMatchingResult(param, parsedResults);
          
          if (machineResult) {
            mappedCount++;
            return { ...param, result: machineResult.value };
          }
          return param;
        });
        
        return {
          ...test,
          params: updatedParams,
          impression: '',
          notes: '',
          interpretation: test.interpretation || ''
        };
      });

      // Update form data
      setFormData(prev => ({
        ...prev,
        test_id0: patient.lab_item_parent,
        l11: updatedTests
      }));

      // Update stats
      setImportedCount(prev => prev + mappedCount);
      setLastImportTime(new Date());
      
      toast.success(`✅ Auto-imported ${mappedCount} results for ${patient.lab_reg_name}`);
      addToLog(`Success: ${patient.lab_reg_name} (${patient.lab_reg_uhid}) - ${mappedCount} results`, 'success');

    } catch (error) {
      console.error('Auto-import error:', error);
      toast.error('Auto-import failed');
      addToLog(`Error: ${error.message}`, 'error');
    }
  };

  // Find matching result
  const findMatchingResult = (param, results) => {
    const testCodeColumns = [
      'TestCode', 'Test_Code', 'test_code', 'CODE', 'Code',
      'TestID', 'Test_ID', 'test_id', 'ID', 'Test'
    ];
    
    const resultColumns = [
      'Result', 'RESULT', 'result', 'Value', 'VALUE', 'value'
    ];

    for (const row of results) {
      // Match by code
      for (const codeCol of testCodeColumns) {
        if (row[codeCol]) {
          const machineCode = String(row[codeCol]).trim().toUpperCase();
          const internalCode = String(param.test_param_code || '').trim().toUpperCase();
          
          if (machineCode && internalCode && machineCode === internalCode) {
            for (const resultCol of resultColumns) {
              if (row[resultCol] !== undefined && row[resultCol] !== '') {
                return { value: String(row[resultCol]).trim() };
              }
            }
          }
        }
      }
      
      // Match by name
      const testNameColumns = ['TestName', 'Test_Name', 'test_name', 'NAME', 'Name'];
      for (const nameCol of testNameColumns) {
        if (row[nameCol]) {
          const machineName = String(row[nameCol]).trim().toLowerCase();
          const internalName = String(param.test_param_name || '').trim().toLowerCase();
          
          if (machineName && internalName && machineName === internalName) {
            for (const resultCol of resultColumns) {
              if (row[resultCol] !== undefined && row[resultCol] !== '') {
                return { value: String(row[resultCol]).trim() };
              }
            }
          }
        }
      }
    }
    
    return null;
  };




  // Add to import log
  const addToLog = (message, type = 'info') => {
    const logEntry = {
      time: new Date().toLocaleTimeString(),
      message,
      type
    };
    setImportLog(prev => [logEntry, ...prev].slice(0, 20)); // Keep last 20
  };

  return (
    <div className="" style={{ }}>
      {/* <div className="card-header" style={{ 
        background: autoImportEnabled 
          ? 'linear-gradient(135deg, #11998e 0%, #38ef7d 100%)'
          : 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)', 
        color: 'white' 
      }}>
        <div className="d-flex justify-content-between align-items-center">
          <h5 className="mb-0">
            🤖 Auto LIS Import System
            {autoImportEnabled && (
              <span className="badge bg-success ms-2 pulse">ACTIVE</span>
            )}
          </h5>
          <div className="form-check form-switch">
            <input
              className="form-check-input"
              type="checkbox"
              id="autoImportSwitch"
              checked={autoImportEnabled}
              onChange={toggleAutoImport}
              style={{ width: '50px', height: '25px', cursor: 'pointer' }}
            />
            <label className="form-check-label text-white ms-2" htmlFor="autoImportSwitch">
              {autoImportEnabled ? 'ON' : 'OFF'}
            </label>
          </div>
        </div>
      </div> */}

      <div className="">
        {/* Configuration */}
        {/* <div className="row mb-3">
          <div className="col-md-8">
            <label className="form-label fw-bold">📁 Watch Folder Path</label>
            <input
              type="text"
              className="form-control"
              value={watchFolder}
              onChange={(e) => setWatchFolder(e.target.value)}
              disabled={autoImportEnabled}
              placeholder="e.g., D:\LIS_Import or \\NetworkPath\Import"
            />
            <small className="text-muted">
              Machine should save result files to this folder. System will auto-detect and import.
            </small>
          </div>
          <div className="col-md-4">
            <label className="form-label fw-bold">📊 Status</label>
            <div className={`alert ${autoImportEnabled ? 'alert-success' : 'alert-secondary'} mb-0 py-2`}>
              {autoImportEnabled ? (
                <>
                  <i className="fas fa-check-circle"></i> Monitoring Active
                </>
              ) : (
                <>
                  <i className="fas fa-pause-circle"></i> Stopped
                </>
              )}
            </div>
          </div>
        </div> */}

        {/* Stats */}
        {/* {autoImportEnabled && (
          <div className="row mb-3">
            <div className="col-md-4">
              <div className="card bg-light">
                <div className="card-body py-2">
                  <small className="text-muted">Total Imported</small>
                  <h4 className="mb-0 text-success">{importedCount}</h4>
                </div>
              </div>
            </div>
            <div className="col-md-8">
              <div className="card bg-light">
                <div className="card-body py-2">
                  <small className="text-muted">Last Import</small>
                  <h6 className="mb-0">
                    {lastImportTime ? lastImportTime.toLocaleString() : 'Waiting for files...'}
                  </h6>
                </div>
              </div>
            </div>
          </div>
        )} */}

        {/* Import Log */}
        {/* {importLog.length > 0 && (
          <div className="mt-3">
            <h6 className="mb-2">📋 Recent Activity</h6>
            <div className="border rounded p-2" style={{ maxHeight: '200px', overflowY: 'auto', backgroundColor: '#f8f9fa' }}>
              {importLog.map((log, i) => (
                <div key={i} className={`small mb-1 ${
                  log.type === 'success' ? 'text-success' : 
                  log.type === 'error' ? 'text-danger' : 'text-muted'
                }`}>
                  <strong>[{log.time}]</strong> {log.message}
                </div>
              ))}
            </div>
          </div>
        )} */}

        {/* Instructions */}
        {/* <div className="alert alert-info mt-3 mb-0">
          <strong>📌 How it works:</strong>
          <ol className="mb-0 mt-2">
            <li>Enable auto-import using the switch above</li>
            <li>Machine saves result file to the watch folder</li>
            <li>System auto-detects file and extracts Patient ID</li>
            <li>Matches patient and imports results automatically</li>
            <li>You can verify and save the report</li>
          </ol>
        </div> */}
      </div>

      <style>{`
        @keyframes pulse {
          0%, 100% { opacity: 1; }
          50% { opacity: 0.5; }
        }
        .pulse {
          animation: pulse 2s infinite;
        }
      `}</style>
    </div>
  );
};

export default MachineResultImport;